import './styles/main.scss'
import HeroSlickReactComponent from './scripts/hero-slick.js'
import RecipeSlickReactComponent from './scripts/recipe-slick.js'
import HeroStaticReactComponent from './scripts/hero-static.js'
import RecipeReactComponent from './scripts/recipe.js'
import ProductReactComponent from './scripts/product.js'
import TaxArcReactComponent from './scripts/taxonomy-archive.js'
import PillReactComponent from './scripts/pill-tabs'
import SeasonalReactComponent from './scripts/seasonal'

import './scripts/takeover-nav.js'
import './scripts/general.js'

// import React from 'react'
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';


  const renderIfElementExists = (selector, component) => {
    const rootElement = document.querySelector(selector);
    if (rootElement) {
      ReactDOM.createRoot(rootElement).render(component);
      //console.log(`Running ${selector}`);
    }
  };

  renderIfElementExists("#render-react-hero-slick", <HeroSlickReactComponent />);
  renderIfElementExists("#render-react-recipe-slick", <RecipeSlickReactComponent />);
  renderIfElementExists("#render-react-hero-static", <HeroStaticReactComponent />);
  renderIfElementExists("#render-react-recipe", <RecipeReactComponent />);
  renderIfElementExists("#render-react-product", <ProductReactComponent />);
  renderIfElementExists("#render-react-tax-archive", <TaxArcReactComponent />);
  renderIfElementExists("#render-react-pill-tabs", <PillReactComponent />);
  renderIfElementExists("#render-react-seasonal-cards", <SeasonalReactComponent />);


  document.addEventListener('DOMContentLoaded', function() {
    AOS.init({
      delay: 100,
      disable: 'mobile'
    });
  });
  
// if(document.querySelector("#render-react-imagebanner") !== null){
//     ReactDOM.render(<ImageBannerReactComponent />, document.querySelector("#render-react-imagebanner"));
//     console.log("Running render-react-imagebanner");
// }

// if(document.querySelector("#render-react-postgrid") !== null){
//     ReactDOM.render(<PostGridReactComponent />, document.querySelector("#render-react-postgrid"));
//     console.log("Running render-react-postgrid");
// }

// if(document.querySelector('#render-react-modal') !== null){
//     ReactDOM.render(<ModalReactComponent />, document.querySelector("#render-react-modal"));
//     console.log("Running render-react-modal");
// }
